import React from "react";
import { useT } from "../i18n/I18nProvider";

const HERO = "/elsol-storefront.jpg";
const LOGO = "/elsol-logo.png";

export default function Hero() {
  const { t } = useT();
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 pt-10 md:pt-16 pb-16 md:pb-24 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-6 relative">
          <div
            className="absolute -top-8 -left-6 w-44 h-44 sun-glow el-slow-spin pointer-events-none"
            aria-hidden="true"
          />
          <div className="el-rise inline-flex items-center gap-2 rounded-full bg-[#fef3c7] border border-orange-200 px-3.5 py-1.5 text-[12px] font-semibold tracking-wide text-orange-900 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-[#14532d] animate-pulse" />
            {t("hero.eyebrow")}
          </div>

          <h1
            data-testid="hero-heading"
            className="el-rise font-display font-black text-stone-900 text-[44px] sm:text-[56px] lg:text-[68px] leading-[1.02] tracking-tight"
          >
            {t("hero.h_a")} <span className="text-[#b8420f]">{t("hero.h_mexico")}</span>,
            <br />
            <span className="font-script text-[#14532d] text-[58px] sm:text-[72px] lg:text-[84px] leading-none">
              {t("hero.h_b")}
            </span>{" "}
            <span className="italic text-stone-700">{t("hero.h_c")}</span>
          </h1>

          <p className="el-rise-2 mt-7 text-stone-600 text-[17px] leading-relaxed max-w-xl">
            {t("hero.sub")}
          </p>

          <div className="el-rise-3 mt-9 flex flex-wrap gap-3">
            <a
              href="#categories"
              data-testid="hero-shop-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#b8420f] hover:bg-[#8c2f08] text-white px-7 py-3.5 text-[15px] font-bold tracking-wide shadow-[0_10px_30px_-10px_rgba(184,66,15,0.55)] transition-colors"
            >
              {t("hero.cta_shop")}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
            </a>
            <a
              href="#visit"
              data-testid="hero-visit-btn"
              className="inline-flex items-center gap-2 rounded-full bg-white hover:bg-stone-50 border-2 border-[#14532d] text-[#14532d] px-7 py-3.5 text-[15px] font-bold tracking-wide transition-colors"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              {t("hero.cta_visit")}
            </a>
          </div>

          <div className="mt-10 flex items-center gap-6 text-[13px] text-stone-500">
            <div className="flex items-center gap-2">
              <span className="text-[#b8420f] text-lg leading-none">★★★★★</span>
              <span>{t("hero.stars_note")}</span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 relative">
          <div className="relative aspect-[4/5] sm:aspect-[5/5] rounded-[28px] overflow-hidden shadow-[0_30px_80px_-20px_rgba(28,25,23,0.35)]">
            <img
              src={HERO}
              alt="El Sol Mexican Imports"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-stone-900/35 via-stone-900/5 to-transparent" />

            <div className="absolute top-5 right-5 bg-white/95 backdrop-blur rounded-2xl p-3 shadow-xl flex items-center gap-3 max-w-[220px]">
              <img src={LOGO} alt="" className="h-12 w-12 object-contain" />
              <div className="leading-tight">
                <div className="text-[11px] uppercase tracking-widest text-[#b8420f] font-bold">{t("hero.open_today")}</div>
                <div className="text-[13px] text-stone-700 font-semibold">{t("hero.open_hours")}</div>
              </div>
            </div>

            <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between text-white">
              <div>
                <div className="font-script text-[28px] leading-none text-orange-200 drop-shadow">{t("hero.welcome")}</div>
                <div className="text-[13px] font-semibold mt-1">{t("hero.address_short")}</div>
              </div>
            </div>
          </div>

          <div className="absolute -left-4 -bottom-6 hidden md:flex items-center gap-3 bg-[#14532d] text-white rounded-2xl px-4 py-3 shadow-xl rotate-[-4deg]">
            <div className="font-script text-2xl text-orange-200 leading-none">{t("hero.handmade")}</div>
            <span className="text-orange-200 text-lg leading-none">✦</span>
          </div>
        </div>
      </div>

      <div className="tile-divider mx-5 md:mx-10" aria-hidden="true" />
    </section>
  );
}
